import { OpenAccountMetadataOption } from './types';

export const countries: readonly string[] = [
  `Afghanistan`,
  `Albania`,
  `Algeria`,
  `Andorra`,
  `Angola`,
  `Antigua and Barbuda`,
  `Argentina`,
  `Armenia`,
  `Australia`,
  `Austria`,
  `Azerbaijan`,
  `Bahamas`,
  `Bahrain`,
  `Bangladesh`,
  `Barbados`,
  `Belarus`,
  `Belgium`,
  `Belize`,
  `Benin`,
  `Bhutan`,
  `Bolivia`,
  `Bosnia and Herzegovina`,
  `Botswana`,
  `Brazil`,
  `Brunei`,
  `Bulgaria`,
  `Burkina Faso`,
  `Burundi`,
  `Côte d'Ivoire`,
  `Cabo Verde`,
  `Cambodia`,
  `Cameroon`,
  `Canada`,
  `Central African Republic`,
  `Chad`,
  `Chile`,
  `China`,
  `Colombia`,
  `Comoros`,
  `Congo (Congo-Brazzaville)`,
  `Costa Rica`,
  `Croatia`,
  `Cuba`,
  `Cyprus`,
  `Czechia (Czech Republic)`,
  `Democratic Republic of the Congo`,
  `Denmark`,
  `Djibouti`,
  `Dominica`,
  `Dominican Republic`,
  `Ecuador`,
  `Egypt`,
  `El Salvador`,
  `Equatorial Guinea`,
  `Eritrea`,
  `Estonia`,
  `Eswatini (fmr. "Swaziland")`,
  `Ethiopia`,
  `Fiji`,
  `Finland`,
  `France`,
  `Gabon`,
  `Gambia`,
  `Georgia`,
  `Germany`,
  `Ghana`,
  `Greece`,
  `Grenada`,
  `Guatemala`,
  `Guinea`,
  `Guinea-Bissau`,
  `Guyana`,
  `Haiti`,
  `Holy See`,
  `Honduras`,
  `Hungary`,
  `Iceland`,
  `India`,
  `Indonesia`,
  `Iran`,
  `Iraq`,
  `Ireland`,
  `Israel`,
  `Italy`,
  `Jamaica`,
  `Japan`,
  `Jordan`,
  `Kazakhstan`,
  `Kenya`,
  `Kiribati`,
  `Kuwait`,
  `Kyrgyzstan`,
  `Laos`,
  `Latvia`,
  `Lebanon`,
  `Lesotho`,
  `Liberia`,
  `Libya`,
  `Liechtenstein`,
  `Lithuania`,
  `Luxembourg`,
  `Madagascar`,
  `Malawi`,
  `Malaysia`,
  `Maldives`,
  `Mali`,
  `Malta`,
  `Marshall Islands`,
  `Mauritania`,
  `Mauritius`,
  `Mexico`,
  `Micronesia`,
  `Moldova`,
  `Monaco`,
  `Mongolia`,
  `Montenegro`,
  `Morocco`,
  `Mozambique`,
  `Myanmar (formerly Burma)`,
  `Namibia`,
  `Nauru`,
  `Nepal`,
  `Netherlands`,
  `New Zealand`,
  `Nicaragua`,
  `Niger`,
  `Nigeria`,
  `North Korea`,
  `North Macedonia`,
  `Norway`,
  `Oman`,
  `Pakistan`,
  `Palau`,
  `Palestine State`,
  `Panama`,
  `Papua New Guinea`,
  `Paraguay`,
  `Peru`,
  `Philippines`,
  `Poland`,
  `Portugal`,
  `Qatar`,
  `Romania`,
  `Russia`,
  `Rwanda`,
  `Saint Kitts and Nevis`,
  `Saint Lucia`,
  `Saint Vincent and the Grenadines`,
  `Samoa`,
  `San Marino`,
  `Sao Tome and Principe`,
  `Saudi Arabia`,
  `Senegal`,
  `Serbia`,
  `Seychelles`,
  `Sierra Leone`,
  `Singapore`,
  `Slovakia`,
  `Slovenia`,
  `Solomon Islands`,
  `Somalia`,
  `South Africa`,
  `South Korea`,
  `South Sudan`,
  `Spain`,
  `Sri Lanka`,
  `Sudan`,
  `Suriname`,
  `Sweden`,
  `Switzerland`,
  `Syria`,
  `Tajikistan`,
  `Tanzania`,
  `Thailand`,
  `Timor-Leste`,
  `Togo`,
  `Tonga`,
  `Trinidad and Tobago`,
  `Tunisia`,
  `Turkey`,
  `Turkmenistan`,
  `Tuvalu`,
  `Uganda`,
  `Ukraine`,
  `United Arab Emirates`,
  `United Kingdom`,
  `United States of America`,
  `Uruguay`,
  `Uzbekistan`,
  `Vanuatu`,
  `Venezuela`,
  `Vietnam`,
  `Yemen`,
  `Zambia`,
  `Zimbabwe`,
];

export const currencies: readonly string[] = [
  'AED',
  'AFN',
  'ALL',
  'AMD',
  'ANG',
  'AOA',
  'ARS',
  'AUD',
  'AWG',
  'AZN',
  'BAM',
  'BBD',
  'BDT',
  'BGN',
  'BHD',
  'BIF',
  'BMD',
  'BND',
  'BOB',
  'BRL',
  'BSD',
  'BTN',
  'BWP',
  'BYN',
  'BZD',
  'CAD',
  'CDF',
  'CHF',
  'CLP',
  'CNY',
  'COP',
  'CRC',
  'CUC',
  'CUP',
  'CVE',
  'CZK',
  'DJF',
  'DKK',
  'DOP',
  'DZD',
  'EGP',
  'ERN',
  'ETB',
  'EUR',
  'FJD',
  'FKP',
  'GBP',
  'GEL',
  'GGP',
  'GHS',
  'GIP',
  'GMD',
  'GNF',
  'GTQ',
  'GYD',
  'HKD',
  'HNL',
  'HRK',
  'HTG',
  'HUF',
  'IDR',
  'ILS',
  'IMP',
  'INR',
  'IQD',
  'IRR',
  'ISK',
  'JEP',
  'JMD',
  'JOD',
  'JPY',
  'KES',
  'KGS',
  'KHR',
  'KMF',
  'KPW',
  'KRW',
  'KWD',
  'KYD',
  'KZT',
  'LAK',
  'LBP',
  'LKR',
  'LRD',
  'LSL',
  'LYD',
  'MAD',
  'MDL',
  'MGA',
  'MKD',
  'MMK',
  'MNT',
  'MOP',
  'MRU',
  'MUR',
  'MVR',
  'MWK',
  'MXN',
  'MYR',
  'MZN',
  'NAD',
  'NGN',
  'NIO',
  'NOK',
  'NPR',
  'NZD',
  'OMR',
  'PAB',
  'PEN',
  'PGK',
  'PHP',
  'PKR',
  'PLN',
  'PYG',
  'QAR',
  'RON',
  'RSD',
  'RUB',
  'RWF',
  'SAR',
  'SBD',
  'SCR',
  'SDG',
  'SEK',
  'SGD',
  'SHP',
  'SLL',
  'SOS',
  'SPL',
  'SRD',
  'STN',
  'SVC',
  'SYP',
  'SZL',
  'THB',
  'TJS',
  'TMT',
  'TND',
  'TOP',
  'TRY',
  'TTD',
  'TVD',
  'TWD',
  'TZS',
  'UAH',
  'UGX',
  'USD',
  'UYU',
  'UZS',
  'VEF',
  'VND',
  'VUV',
  'WST',
  'XAF',
  'XCD',
  'XDR',
  'XOF',
  'XPF',
  'YER',
  'ZAR',
  'ZMW',
  'ZWD',
];

export const maritalStatuses: readonly string[] = [
  'Single',
  'Married',
  'Widowed',
  'Divorced',
];

export const levelsOfEducation: readonly string[] = ['Compulsory education', 'Lower secondary school certificate', 'A-levels/secondary school diploma', 'University diploma', 'University diploma+'];

export const previousExperienceExperiences: readonly string[] = [
  'Less than 1 year',
];

export const previousExperienceTransactions: readonly string[] = [
  'More than 25',
];

export const previousExperienceAverageVolumes: readonly string[] = [
  '$0 - $25,000 USD',
];

export function staticToOptions(
  list: readonly string[],
): readonly OpenAccountMetadataOption<any>[] {
  return list.map((entry) => ({
    value: entry,
    text: entry,
    metadata: {},
  }));
}
